import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { getSchedules } from "../../helpers/SchedulesHelper";

import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import parser from "cron-parser";
import axios from "axios";
import config from "../../config";

const localizer = momentLocalizer(moment);

const styles = {
  marginTop: {
    marginTop: "2em",
  },
  smallTitle: {
    fontSize: ".8em",
  },
};

class Schedules extends Component {
  state = {
    isLoading: true,
    schedules: [],
    events: [],
  };

  componentDidMount() {
    let opts = {
      currentDate: new Date().setHours(0, 0, 0, 0),
      tz: "America/New_York",
    };

    axios.get(`${config.schedulerBaseUrl}/debug/schedule`).then((res) =>
    {
      let events = res.data;

      let nEvents = events.map((x) => {
        return {
          ...x,
          start: new Date(x.start),
          end: new Date(x.end)
        };
      });

      this.setState({ events: nEvents });
    }, err => err);
  }

  eventStyleGetter(event, start, end, isSelected) {
    let backgroundColor = `#${event.hexColor}`;
    let color = `black`;

    switch (event.type) {
      case "Record":
        backgroundColor = "#FF3860";
        color = "white";
        break;
      case "View":
        backgroundColor = "#24D160";
        break;
      default:
        break;
    }

    let style = {
      backgroundColor,
      color,
      opacity: 0.9,
      borderColor: "gainsboro",
    };

    return { style };
  }

  render() {
    return (
        <div>
          <section className="hero is-dark">
            <div className="hero-body">
              <div className="container">
                <h1 className="title">Schedules</h1>
                <h2 className="subtitle">Automatically Scheduled Events</h2>
              </div>
            </div>
          </section>

          <div className="container" style={styles.marginTop}>
            <Calendar
                localizer={localizer}
                events={this.state.events}
                defaultDate={new Date()}
                defaultView="agenda"
                startAccessor="start"
                endAccessor="end"
                style={{ height: "100vh" }}
                eventPropGetter={this.eventStyleGetter}
            />
          </div>
        </div>
    );
  }
}

export default Schedules;
